import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CommonSideNavbar from "../common/CommonSideNavbar";
import {
  superAdminDashboard,
  superAdminProfile,
  activeLinkDashboard,
} from "../common/allLinks";
import AddNewAgencyDetailsContactTabPanel from "./AddNewAgencyDetailsContactTabPanel";
import AddNewAgencyDetailsLoginTabPanel from "./AddNewAgencyDetailsLoginTabPanel";
import AddNewAgencyDetailsTabPanel from "./AddNewAgencyDetailsTabPanel";
import BreadcrumbMenu from "../common/BreadcrumbMenu";
import { useLocation } from "react-router";

export default function AddNewAgency() {
  const [activeTabIndex, setActiveTabIndex] = useState(
    isNaN(
      parseInt(localStorage.getItem("clientDashboardAddNewRequirementTabIndex"))
    )
      ? 0
      : parseInt(
          localStorage.getItem("clientDashboardAddNewRequirementTabIndex")
        )
  );

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOnSelect = (val) => {
    // activeAddNewAgencyTabIndex
    localStorage.setItem("activeAddNewAgencyTabIndex", val);
    setActiveTabIndex(val);
  };

  useEffect(() => {
    localStorage.setItem("activeSuperAdminDashboardTabIndex", 0);
    return () => {
      localStorage.removeItem("activeAddNewAgencyTabIndex");
    };
  }, []);

  const isEditForm =
    location.state !== null && location.state.isEditForm ? true : false;

  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={superAdminDashboard}
        profileLink={superAdminProfile}
        activeLink={activeLinkDashboard}
      />

      <div className="sidenavbar-active-menu-page">
        <div className="mt-title-block">
          <BreadcrumbMenu
            menuObj={[
              {
                title: "Dashboard",
                type: "goBackButton",
              },
              {
                title: !isEditForm ? "Create New Agency" : "Edit Agency",
              },
            ]}
          />

          {!isEditForm ? (
            <h1 className="mt-dashboard-title">Create New Agency</h1>
          ) : (
            <h1 className="mt-dashboard-title">Edit Agency</h1>
          )}
        </div>
        <div className="mt-platform-tabs">
          <Tabs
            defaultIndex={parseInt(
              localStorage.getItem("activeAddNewAgencyTabIndex")
            )}
            onSelect={handleOnSelect}
            selectedIndex={activeTabIndex}
          >
            <TabList>
              <Tab>Agency Details</Tab>
              <Tab>Contact Details</Tab>
              <Tab>Login Details</Tab>
            </TabList>
            <TabPanel>
              <AddNewAgencyDetailsTabPanel handleOnSelect={handleOnSelect} />
            </TabPanel>
            <TabPanel>
              <AddNewAgencyDetailsContactTabPanel
                handleOnSelect={handleOnSelect}
              />
            </TabPanel>
            <TabPanel>
              <AddNewAgencyDetailsLoginTabPanel />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
